"use client";

import Image from "next/image";

export default function LearningWithIndustry() {
  return (
    <section className="relative w-full overflow-hidden">
      {/* Orange Background Top Section */}
      <div className="bg-[#FFA201] pt-16 pb-24 md:pt-10 md:pb-32">
        <div className="page-container mx-auto">
          <div className="max-w-5xl">
            <h2 className="text-3xl md:text-4xl font-bold text-black mb-6">
              Learning With Industry
            </h2>
            <p className="text-black text-sm md:text-base lg:text-lg leading-relaxed">
              Our learning model is designed around deep industry integration,
              where practice leads learning. With nearly 70% of the curriculum
              delivered through hands-on, work-integrated experiences, industry
              becomes an extended campus for our students. Through on-the-job
              learning, live projects, workshops, and industry-led training,
              learners gain real-world exposure while they learn and earn. This
              approach ensures students graduate with relevant skills and
              workplace readiness.
            </p>
          </div>
        </div>
      </div>

      {/* Overlapping Images Section */}
      <div className="page-container mx-auto -mt-16 md:-mt-24 pb-8 md:pb-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
          <div className="relative aspect-[4/3] shadow-2xl overflow-hidden group">
            <Image
              src="https://cdn.msu.edu.in/msu-reavamp/images/in-the-media/Skills-in-higher-education.jpg"
              alt="Industry Integration 1"
              fill
              className="object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
          <div className="relative aspect-[4/3] shadow-2xl overflow-hidden group">
            <Image
              src="https://cdn.msu.edu.in/school_of_health_science_and_technology_students_af7ff3ca2c.jpg"
              alt="Industry Integration 2"
              fill
              className="object-cover transition-transform duration-500 group-hover:scale-105"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
